module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hres7de-detail-tab4"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#tab4"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES7DEP4']['10']) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "tab4"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES7DEP4']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTab4.dessummary),
      expression: "detailTab4.dessummary"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:600'),
      expression: "'max:600'"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "600",
      "data-vv-name": "dessummary",
      "has-error": _vm.errors.has('dessummary')
    },
    domProps: {
      "value": (_vm.detailTab4.dessummary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detailTab4, "dessummary", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dessummary')),
      expression: "errors.has('dessummary')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dessummary')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(600)))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES7DEP4']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTab4.desbenefit),
      expression: "detailTab4.desbenefit"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:600'),
      expression: "'max:600'"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "600",
      "data-vv-name": "desbenefit",
      "has-error": _vm.errors.has('desbenefit')
    },
    domProps: {
      "value": (_vm.detailTab4.desbenefit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detailTab4, "desbenefit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('desbenefit')),
      expression: "errors.has('desbenefit')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('desbenefit')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(600)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES7DEP4']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTab4.descomment),
      expression: "detailTab4.descomment"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:600'),
      expression: "'max:600'"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "600",
      "data-vv-name": "descomment",
      "has-error": _vm.errors.has('descomment')
    },
    domProps: {
      "value": (_vm.detailTab4.descomment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detailTab4, "descomment", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('descomment')),
      expression: "errors.has('descomment')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('descomment')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(600)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0aed51d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres7de/detailTab4.vue
// module id = 3538
// module chunks = 1